import { combineReducers } from "redux";

import { statisticsConstants } from "../actions/statistics";

function totals(state, { type, payload }) {
  let defaultState = typeof state === "undefined" ? null : state;
  if (type === statisticsConstants.GET_TOTALS_COMPANY_SUCCESS) {
    return {
      ...defaultState,
      companyId: payload.companyId,
      results: payload.totals
    };
  } 
  return defaultState;
  
}

function dates(state, { type, payload }) {
  let defaultState = typeof state === "undefined" ? null : state;
  if (type === statisticsConstants.GET_STATISTICS_SUCCESS) {
    if (payload.stats.statistics !== null) {
      return {
        ...defaultState,
        companyId: payload.companyId,
        accountantId: payload.accountantId,
        ...payload.stats.statistics
      };
    }
    return {
      accountantId: payload.accountantId,
      companyId: payload.companyId,
      ...null
    };
  } 
  return defaultState;
  
}

function isGettingStatistics(state, { type }) {
  let defaultState = typeof state === "undefined" ? false : state;
  switch (type) {
  case statisticsConstants.GET_TOTALS_COMPANY_START:
    return true;
  case statisticsConstants.GET_TOTALS_COMPANY_SUCCESS:
  case statisticsConstants.GET_TOTALS_COMPANY_ERROR:
    return false;
  default:
    return defaultState;
  }
}

function isErrorGettingStatistics(state, { type, error }) {
  let defaultState = typeof state === "undefined" ? false : state;
  switch (type) {
  case statisticsConstants.GET_TOTALS_COMPANY_ERROR:
    return true;
  case statisticsConstants.GET_TOTALS_COMPANY_START:
  case statisticsConstants.GET_TOTALS_COMPANY_SUCCESS:
    return false;
  default:
    return defaultState;
  }
}

function isGettingDates(state, { type }) {
  let defaultState = typeof state === "undefined" ? false : state;
  switch (type) {
  case statisticsConstants.GET_STATISTICS_START:
    return true;
  case statisticsConstants.GET_STATISTICS_SUCCESS:
  case statisticsConstants.GET_STATISTICS_ERROR:
    return false;
  default:
    return defaultState;
  }
}

function isErrorGettingDates(state, { type, error }) {
  let defaultState = typeof state === "undefined" ? false : state;
  switch (type) {
  case statisticsConstants.GET_STATISTICS_ERROR:
    return true;
  case statisticsConstants.GET_STATISTICS_START:
  case statisticsConstants.GET_STATISTICS_SUCCESS:
    return false;
  default:
    return defaultState;
  }
}

function totalsDocumentsByCategory(state, { type, payload }) {
  let defaultState = typeof state === "undefined" ? null : state;
  if (type === statisticsConstants.GET_COUNT_DOCUMENTS_SUCCESS) {
    return {
      results: payload.totals
    };
  } else if (type === statisticsConstants.GET_COUNT_DOCUMENTS_ERROR) {
    return null;
  } 
  return defaultState;
  
}

function isGettingCountDocumentsByCategory(state, { type }) {
  let defaultState = typeof state === "undefined" ? false : state;
  switch (type) {
  case statisticsConstants.GET_COUNT_DOCUMENTS_START:
    return true;
  case statisticsConstants.GET_COUNT_DOCUMENTS_SUCCESS:
  case statisticsConstants.GET_COUNT_DOCUMENTS_ERROR:
    return false;
  default:
    return defaultState;
  }
}

export const statistics = combineReducers({
  totals,
  totalsDocumentsByCategory,
  dates,
  isGettingCountDocumentsByCategory,
  isGettingStatistics,
  isGettingDates,
  isErrorGettingStatistics,
  isErrorGettingDates
});

export default statistics;
